import styled, { keyframes } from 'styled-components'

const scroll = keyframes`
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(-100%);
  }
`

export const LogoCarouselContainer = styled.div`
    position: relative;
    overflow: hidden;
    width: 100%;
    max-width: 490px;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #1f4fff;

    &:before,
    &:after {
        content: '';
        position: absolute;
        top: 0;
        width: 100px;
        height: 100%;
        pointer-events: none;
        z-index: 1;
    }

    &:before {
        left: 0;
        background: linear-gradient(to right, #1f4fff 0%, rgba(240, 240, 240, 0) 60%);
    }

    &:after {
        right: 0;
        background: linear-gradient(to left, #1f4fff 0%, rgba(240, 240, 240, 0) 60%);
    }
`

export const LogoRow = styled.div`
    display: flex;
    gap: 0;
    animation: ${scroll} 220s linear infinite;
    width: max-content;
`

export const LogoItem = styled.div`
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 100px;

    img {
        max-height: 60px;
        object-fit: contain;
    }
`
